// SubscriptionCheck.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { resolveSubscriptionDoc } from './subscriptionDoc';
import { ensureTrialOnFirstLogin } from './trialUtils';

const SubscriptionCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true; // prevent state updates after unmount

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user && isMounted) {
        const phoneNumber = user.phoneNumber;

        try {
          const { snap: docSnap } = await resolveSubscriptionDoc(phoneNumber);

          if (docSnap.exists()) {
            // 🔁 ORIGINAL PATH: unchanged
            const subscriptionData = docSnap.data();
            const currentTime = new Date();

            let endDate;
            if (subscriptionData.endDate) {
              if (subscriptionData.endDate.toDate) {
                // Firestore Timestamp
                endDate = subscriptionData.endDate.toDate();
              } else if (typeof subscriptionData.endDate === 'string') {
                // ISO String
                endDate = new Date(subscriptionData.endDate);
              } else {
                // Already a Date
                endDate = subscriptionData.endDate;
              }

              if (endDate && endDate.getTime() > currentTime.getTime()) {
                // Active (trial or paid)
                navigate('/tender-selection');
              } else {
                // Expired
                navigate('/subscription');
              }
            } else {
              // No endDate field
              navigate('/subscription');
            }
          } else {
            // True first login (no canonical + no legacy subscription doc) -> create demo.
            await ensureTrialOnFirstLogin(phoneNumber);
            const { snap: afterSnap } = await resolveSubscriptionDoc(phoneNumber);
            if (afterSnap.exists()) navigate('/tender-selection');
            else navigate('/subscription');
          }
        } catch (error) {
          console.error('Error checking subscription:', error);
          navigate('/subscription');  // on error, go to subscription
        }
      } else {
        // Not logged in
        navigate('/login');
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [navigate]);

  return null; // no UI; it just redirects
};

export default SubscriptionCheck;
